import { TTnaBoardActions } from './tna-board.actions';
import { TNA_BOARD_ITEMS_PER_PAGE_LIST } from './tna-board.facade';
import { TTnaBoardActionType, TTnaBoardState } from './tna-board.models';

export const initialState: TTnaBoardState = {
  tnaBoardInfo: null,
  userPaginationOption: {
    pageNo: 1,
    pageSize: TNA_BOARD_ITEMS_PER_PAGE_LIST[0],
  },
};

export function tnaBoardReducer(state = initialState, action: TTnaBoardActions): TTnaBoardState {
  switch (action.type) {
    case TTnaBoardActionType.GetTnaBoardListSucess:
      return {
        ...state,
        tnaBoardInfo: action.payload,
      };
    default:
      return state;
  }
}
